import { render, staticRenderFns } from "./xhDayPrice.vue?vue&type=template&id=c90e0da2"
import script from "./xhDayPrice.vue?vue&type=script&lang=js"
export * from "./xhDayPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports